import React, { useEffect } from 'react';
import Footer from "../../../components/Footer/Footer";
import { useNavigate } from "react-router-dom";
import { useScrollHeader } from '../../../hooks';
import NewsSidebar from "../../../components/NewsSidebar/NewsSidebar";

export default function CellReportsAmblyopia({ setHeaderDark }) {
  useScrollHeader(setHeaderDark, 50); // 50px 触发
  const navigate = useNavigate();

  const newsData = [
    {
      title: '出圈2026VC！｜集视医疗发布“全龄弱视诊疗黑科技”：基于脑科学机制，突破年龄限制',
      date: '2026-06',
      desc: '津门聚智，睛启新篇！备受行业瞩目的2026视觉健康创新发展国际会议（Vision China 2026）近日在天津圆满落幕。',
      img: '/images/news/jishiAllAgeAmblyopia8.jpg',
      route: '/newsInfo/jishiAllAgeAmblyopia'
    },
    {
      title: '突破弱视诊疗年龄瓶颈，集视医疗携脑科学驱动方案亮相全国小儿眼科年会',
      date: '2026-06',
      desc: '以“脑科学机制驱动・眼脑融合创新”为核心定位的集视医疗，在2026中华医学会斜视与小儿眼科学术大会上精彩亮相，向业界展示了旗下基于脑科学机制的弱视治疗解决方案——埃尔塔（ARTA），与全国眼科专家共探弱视诊疗前沿路径，引发行业广泛关注与认可。',
      img: '/images/news/pediatricConference8.jpg',
      route: '/newsInfo/pediatricConference'
    },
    {
      title: '温州医科大学附属眼视光医院＆集视医疗战略合作签约',
      date: '2024-10-31',
      desc: '2024年10月，集视医疗与温州医科大学附属眼视光医院达成了一项具有里程碑意义的战略合作协议。根据协议，集视医疗的视功能训练产品将正式入驻温州医科大学附属眼视光医院的视功能训练室…',
      img: '/images/news/news1.png',
      route: '/newsInfo/contract'
    },
  ]

  useEffect(() => {
    window.scrollTo(0, 0); // 进入页面时滚动到顶部
  }, []);

  return <div className="PreA">
    <div className="nav">
      <div className="AcademicMargin flex_row flex_jc-sb flex_ai-c gap_10" style={{ height: '100%' }}>
        <div className='nav_title c_ff'>公司动态 / 最新资讯 / Cell Reports重磅：首次揭示成人弱视神经学病理机制，首创全龄优效弱视诊疗方案</div>
        <div
          className='fz_20 fw_500 lh_24 c_ff cur_p flex_row flex_ai-c'
          onClick={(() => navigate('/companyNews', { replace: true }))}
        >
          <img
            className='nav_arrow'
            src='/images/news/left.png'
            alt=''
          />
          <div className='nav_back'>返回页面</div>
        </div>
      </div>
    </div>
    <div className="AcademicBlock">
      <div className='PreA_left'>
        <div className='PreA_marginMobile flex_col flex_jc-sb'>
          <div>
            <div className='article_title'>
              <div className='article_titleTop c_85899E'>
                公司动态 / 公司资讯
                <span className='ml_54'>2026.06</span>
              </div>
              <div className="article_titleBottom">Cell Reports重磅：首次揭示成人弱视神经学病理机制，首创全龄优效弱视诊疗方案</div>
            </div>
            <div className='article_content'>
              <div className="PreA_img2">
                <img
                  style={{ width: '100%' }}
                  src='/images/news/cellReportsAmblyopia1.png'
                  alt=''
                />
              </div>
              <div className="article_content-text">
                北京时间 2021 年 12 月 14 日，国际顶级学术期刊《Cell Reports》在线发表了由复旦大学附属眼耳鼻喉科医院文雯团队和中科院生物物理所张朋团队领衔的研究成果《成人人类弱视中膝状 - 纹状与皮质 - 顶盖通路的层选择性信号缺失与增强》。
                该研究联合 3T 和 7T 超高分辨率 BOLD fMRI 技术，结合精心设计的大细胞（M）/ 小细胞（P）通路特异性视觉刺激，对 17 名单侧弱视成人患者和 17 名正常对照者进行了对照研究，取得了里程碑式的发现：
              </div>
              <div className="PreA_img2 flex_center">
                <img
                  style={{ width: '80%' }}
                  src='/images/news/cellReportsAmblyopia2.png'
                  alt=''
                />
                <div className='img_tip'>AE: amblyopic eye; FE: fellow eye; NE: normal eye</div>
              </div>
              <div className='article_content-text1'>外侧膝状体小细胞层（P 层）存在选择性功能缺陷</div>
              <div className='article_content-text'>
                这是本研究最核心的发现，首次在人类中直接证实弱视对 LGN 的损伤具有通路和层特异性：<br />
                • 弱视眼对持续颜色刺激（P 通路特异性）和高对比度消色刺激的反应，在 LGN 背侧 P 层显著降低，而腹侧 M 层反应无明显异常；<br />
                • 弱视眼的 LGN 到初级视皮层（V1）的前馈有效连接显著减弱，且连接强度与弱视眼的视力下降程度呈正相关； <br />
                • 弱视患者与正常对照者的 LGN 总体积无统计学差异，提示该损伤为功能性而非结构性改变。
              </div>
              <div className="PreA_img2 flex_center">
                <img
                  style={{ width: '80%' }}
                  src='/images/news/cellReportsAmblyopia3.png'
                  alt=''
                />
                <img
                  style={{ width: '80%' }}
                  src='/images/news/cellReportsAmblyopia4.png'
                  alt=''
                />
              </div>
              <div className='article_content-text'>
                弱视是儿童期最常见的视觉发育障碍性疾病，全球患病率约 2%-5%，多由斜视、屈光参差等关键期异常视觉经验导致，即使矫正屈光不正后仍存在不可逆的视功能损伤。长期以来，学术界普遍认为弱视的神经损伤仅局限于视皮层，而皮层下通路的作用因技术限制一直未被明确解析。<br /><br />
                既往动物模型虽发现弱视眼外侧膝状体（LGN）存在细胞萎缩，但人类研究受限于非侵入性层特异性检测技术的缺失，关于弱视是否影响皮层下通路、以及影响的通路特异性和层选择性，始终存在争议。同时，弱视患者普遍存在的注视不稳、注意力缺陷等症状，也无法单纯用视皮层损伤完全解释。<br /><br />
                该研究的发现突破了人类皮层下核团层特异性活动检测的技术瓶颈，首次系统揭示了成人弱视患者皮层下视觉通路的功能异常模式，挑战了 “弱视缺陷仅源于视皮层” 的传统主流观点，为弱视的精准诊断和治疗革新提供了全新的神经科学依据。
              </div>
              <div className='article_content-text1'>集视医疗埃尔塔弱视诊疗方案</div>
              <div className='article_content-text'>
                埃尔塔弱视诊疗产品正是基于研究中揭示的弱视通路特异性缺陷机制，将其融入产品研发核心，推出适配全年龄段弱视人群的相关辅助干预产品，聚焦膝状-纹状与皮质-顶盖通路的功能调节，兼顾院内临床干预与居家康复场景，提升患者干预依从性，为市场推广奠定了科学基础（温馨提示：产品不能替代药物或手术治疗，不具备疾病治愈功效，需在专业医师指导下使用）。<br /><br />
                而且值得一提的是，从文雯教授团队主导完成的小样本探索性 IIT 研究到大规模 RCT 临床试验数据来看：<br /><br />
                既往 IIT 研究已证实：仅需6 个月标准化训练，埃尔塔弱视训练对 12 岁以下儿童弱视的治疗有效率即超 90%，对 18 岁以上成人弱视的有效率达 77.3%，疗效显著优于传统遮盖疗法及所有已获 FDA 批准的同类疗法。<br /><br />
                最新RCT中期分析结果进一步验证：本研究采用与金标准遮盖疗法的头对头对照设计，经过 3 个月标准化训练，成人组有效率即达 60%，显著优于遮盖对照组，达到预设的优效性终点。<br /><br />
                尤为突出的是，在双眼融合与立体视功能恢复方面，埃尔塔方案展现出显著优势，自第一次访视期起即出现统计学显著提升，且提升幅度明显优于传统遮盖疗法。<br /><br />
                随着训练周期的延长，我们有充分依据预判，基于双眼小细胞通路推拉范式的训练方案临床疗效将持续提升，有望为全年龄段弱视患者带来更优的治疗结局。
              </div>
              <div className='mt_60 img_tip'>合规免责声明：本文仅用于学术科研交流，文中所有临床试验数据均为特定条件下阶段性样本科研观察结果，受个人眼部基础、依从程度等因素影响，不同使用者实际表现存在显著个体差异，不能作为产品疗效承诺；本文内容不构成任何诊疗建议，眼部相关疾病请前往正规医疗机构遵医嘱就诊。</div>
            </div>
          </div>
          <div className='article_content'>
            <div className='article_content-iconBlock'>
              <div className='PreA_left-icon flex_center'>
                <img
                  src='/images/news/Share_icon.png'
                  alt=''
                />
              </div>
              <div className='PreA_left-icon flex_center'>
                <img
                  src='/images/news/Collection_icon.png'
                  alt=''
                />
              </div>
              <div className='PreA_left-icon flex_center'>
                <img
                  src='/images/news/link_icon.png'
                  alt=''
                />
              </div>
            </div>
            <div className='article_content-btnBlock'>
              {/* Pc端 */}
              <div
                className='article_content-btnPc fz_20 fw_500 lh_24 cur_p flex_row flex_ai-c'
                onClick={(() => navigate('/newsInfo/twoCitiesAcademic'))}
              >
                <img
                  className='nav_arrow mr_10'
                  src='/images/news/blackLeft.png'
                  alt=''
                />
                阅读上一篇资讯
              </div>
              <div
                className='article_content-btnPc fz_20 fw_500 lh_24 cur_p flex_row flex_ai-c'
                onClick={(() => navigate('/newsInfo/jishiAllAgeAmblyopia'))}
              >
                阅读下一篇资讯
                <img
                  className='nav_arrow ml_10'
                  src='/images/news/blackRight.png'
                  alt=''
                />
              </div>
              {/* 移动端 */}
              <div
                className='article_content-btnMobile fz_16 fw_400 lh_18 cur_p flex_row flex_ai-c'
                onClick={(() => navigate('/newsInfo/twoCitiesAcademic'))}
              >
                <img
                  className='nav_arrow mr_6'
                  src='/images/news/blackLeft.png'
                  alt=''
                />
                上一篇
              </div>
              <div
                className='article_content-btnMobile fz_16 fw_400 lh_18 cur_p flex_row flex_ai-c'
                onClick={(() => navigate('/newsInfo/jishiAllAgeAmblyopia'))}
              >
                下一篇
                <img
                  className='nav_arrow ml_6'
                  src='/images/news/blackRight.png'
                  alt=''
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <NewsSidebar newsData={newsData} />
    </div>
    <Footer />
  </div>
}
